import Enumerator from '../global/Enumerator';

export const documentCategories = [
  'credit_guide',
  'privacy_disclosure',
  'fact_find',
  'preliminary_assessment',
  'credit_proposal_disclosure',
  'credit_quote',
  'sales_document'
];

export const documentTypes = ['generic', 'document', 'image', 'video', 'music'];

export class DocumentCategory extends Enumerator {
  static default() {
    return this.of('sales_document');
  }
}
DocumentCategory.initEnum({
  credit_guide: {
    get id() {
      return 1;
    },
    get title() {
      return 'Credit Guide';
    },
    get isRequired() {
      return true;
    },
    get isCompliance() {
      return false;
    },
    get weight() {
      return 1;
    }
  },
  privacy_disclosure: {
    get id() {
      return 2;
    },
    get title() {
      return 'Privacy Disclosure';
    },
    get isRequired() {
      return true;
    },
    get isCompliance() {
      return false;
    },
    get weight() {
      return 2;
    }
  },
  fact_find: {
    get id() {
      return 3;
    },
    get title() {
      return 'Fact Find';
    },
    get isRequired() {
      return false;
    },
    get isCompliance() {
      return false;
    },
    get weight() {
      return 3;
    }
  },
  preliminary_assessment: {
    get id() {
      return 4;
    },
    get title() {
      return 'Preliminary Assessment';
    },
    get isRequired() {
      return true;
    },
    get isCompliance() {
      return true;
    },
    get weight() {
      return 4;
    }
  },
  credit_proposal_disclosure: {
    get id() {
      return 5;
    },
    get title() {
      return 'Credit Proposal Disclosure';
    },
    get isRequired() {
      return true;
    },
    get isCompliance() {
      return true;
    },
    get weight() {
      return 5;
    }
  },
  credit_quote: {
    get id() {
      return 6;
    },
    get title() {
      return 'Credit Quote';
    },
    get isRequired() {
      return false;
    },
    get isCompliance() {
      return false;
    },
    get weight() {
      return 6;
    }
  },
  sales_document: {
    get id() {
      return 7;
    },
    get title() {
      return 'Sales Document';
    },
    get isRequired() {
      return false;
    },
    get isCompliance() {
      return false;
    },
    get weight() {
      return 7;
    }
  }
});

export class DocumentType extends Enumerator {
  static default() {
    return this.of('document');
  }
}

DocumentType.initEnum({
  generic: {
    get icon() {
      return 'insert_drive_file';
    },
    get extensions() {
      return '';
    }
  },
  document: {
    get icon() {
      return 'description';
    },
    get extensions() {
      return 'doc,docx,xls,xlsx,ppt,pptx,pdf,rtf,txt,md';
    }
  },
  image: {
    get icon() {
      return 'photo';
    },
    get extensions() {
      return 'gif,jpg,jpeg,png,bmp,tif,tiff';
    }
  },
  video: {
    get icon() {
      return 'ondemand_video';
    },
    get extensions() {
      return 'avi,mov,mp4,wmv,ogg';
    }
  },
  music: {
    get icon() {
      return 'music_note';
    },
    get extensions() {
      return 'aac,flac,mp3';
    }
  }
});

export default {
  documentCategories,
  DocumentCategory,
  documentTypes,
  DocumentType
};
